module.exports = __webpack_public_path__ + "img/start-point.51f496f9.png";